<template>
    <div class="row task-container"  >
        <div class="col-md-12">
            <template v-if="tableId === 'activeSupportTasksTableBackups'">
                <button class="btn btn-primary" :disabled="resolveAllLoader" @click="resolveAllBackupTasks">
                    <div class="loader small_loader" v-if="resolveAllLoader"></div>
                    <span v-else>Resolve All</span>
                </button>
                <br/><br/>
            </template>
            <table class="table table-striped task-table table-responsive" :id="tableId" v-if="tasks">
                <thead>
                    <tr>
                        <th>Task Type</th>
                        <th>Domain</th>
                        <th v-if="type === 'uniqueVisitors'">Server IP</th>
                        <th v-if="type!=='uniqueVisitors'">Email</th>
                        <th  v-if="tableId.toLowerCase().includes('sales')">Name</th>
                        <th v-if="tableId === 'activeSupportTasksTableMigrations' && type !== 'migration'" class="text-center">CF Status</th>
                        <th class="text-center">WPO Status</th>
<!--                        <th v-if="tableId === 'activeSupportTasksTable'" class="text-center">HB Status</th>-->
                        <th class="text-center">Created At</th>
                        <th class="text-center" v-if="type === 'resolved'">Resolved By</th>
                        <th class="text-center" v-if="type === 'migration'">Initiated Before </th>
                        <th class="text-center" v-if="type === 'active' || type === 'migration' || type === 'uniqueVisitors'">Checkin</th>
                        <th v-if="tableId === 'activeMVIntegrationTable'" class="text-center">CF Activated</th>
                        <th class="text-center" v-if="type === 'active' || type === 'migration' || type === 'resolved' ">Action <i class="fa fa-bolt"></i></th>

                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(task,index) in tasks" :key="'queueTask_' + index">
                        <td>
                           {{task.text === 'BackUpFailed' ? 'Failed BackUp' : task.text}}
                          <a href="javascript:void(0)" v-if="task.extraDetail" @click="openDetailModal(task)"> - {{task.extraDetail.title}}</a>
                          <a href="javascript:void(0)" v-if="task.storageDetails" @click="openStorageDetailModal(task)"> - View Details</a>
                          <span v-if="task.api_request" class="make-cursor-pointer" title="Pending Job - API will resolve the task automatically." data-toggle="tooltip" data-placement="top" key="api_request" data-html="true"  >⚠️</span>
                          <span v-if="task.text === 'Sub-Sites Limit Reached'" class="make-cursor-pointer" title="Ask khan if you have any question." data-toggle="tooltip" data-placement="top" key="api_request" data-html="true"  >⚠️</span>
                        </td>
                        <td>{{task.domain}}  <i  v-if="type === 'uniqueVisitors'" class="fa fa-copy text-primary mr-2 cursor-pointer" @click="doCopy(task.domain)" /></td>
                        <td v-if="type === 'uniqueVisitors'">{{task.serverip}} <i class="fa fa-copy text-primary mr-2 cursor-pointer" @click="doCopy(task.serverip)" /></td>
                        <td width="10%"  v-if="type!=='uniqueVisitors'">{{task.email}}</td>
                        <td v-if="tableId.toLowerCase().includes('sales')">{{task.name}}</td>
                        <td v-if="tableId === 'activeSupportTasksTableMigrations' && type!='migration'" class="text-center cf-status-icons">
                            <i :title="(task.sslStatus === 'full') ? 'SSL - FULL' : (task.sslStatus === 'flexible') ? 'SSL - FLEXIBLE' : 'SSL - Not Active'"
                               :class="{'fa fa-lock mr-3 disabled' : (task.sslStatus ===  false || task.sslStatus ===  undefined),
                                        'fa fa-lock mr-3 enabled' : task.sslStatus === 'full',
                                        'fa fa-lock mr-3 yellow' : task.sslStatus === 'flexible'}"></i>

                            <i :title="(task.cfStatus === 'paused') ? 'CF - Paused' : (task.cfStatus === true) ? 'CF - Active & Un-Paused'  : 'CF - Not Active'"
                               :class="{'fa fa-cloud disabled' : (task.cfStatus === undefined || task.cfStatus === false),
                                        'fa fa-cloud yellow' : task.cfStatus === 'paused',
                                        'fa fa-cloud enabled': task.cfStatus === true}"></i>
                        </td>
                        <td class="text-center">
                            <span v-if="task.status === 'pending'" class="badge badge-warning">{{task.status}}</span>
                            <span v-else class="badge badge-success">{{task.status}}</span>
                        </td>
<!--                        <td v-if="tableId === 'activeSupportTasksTable'" :class="{'text-center':typeof hbStatuses[index] !== 'undefined'}">-->
<!--                            <span v-if="typeof hbStatuses[index] === 'undefined'" class="loading-dots text-danger" style="font-size:15px">Updating</span>-->
<!--                            <span v-else class="badge badge-info">{{ hbStatuses[index] }}</span>-->
<!--                        </td>-->
                        <td class="text-center">
                            <span class="badge badge-info">{{getDate(task.createdAt)}}</span>
                        </td>
                        <td v-if="type === 'resolved'" class="text-center">
                            <span class="badge badge-primary">{{task.resolvedBy}}</span>
                            <span class="badge badge-info">{{getDate(task.resolvedAt)}}</span>
                        </td>

                        <td v-if="type==='migration'" class="text-center">{{calculateTime(task.createdAt)}}</td>

                      <td width="2%" class="text-center" v-if="tableId === 'activeMVIntegrationTable'">
                        <span v-if="task.activationDate" class="badge badge-pill badge-info">{{ getDate(task.activationDate)}}</span>
                      </td>
                      <td v-if="type === 'active' || type === 'migration' || type === 'uniqueVisitors' || type === 'resolved'" class="text-center">
                        <button v-if="type === 'resolved'" class="btn btn-primary btn-sm mr-2" @click="unResolveTask(task, index)">
                          <div class="loader mini_loader" v-if="selectedIndex === index"></div>
                          <span v-else>UnResolve</span>
                        </button>
                          <button v-else-if="!task.checkinBy" :disabled="selectedIndex === index" class="btn btn-primary btn-sm mr-2" @click="checkinFailedBackupTask({task, index})">
                            <div class="loader mini_loader" v-if="selectedIndex === index"></div>
                            <span v-else>Checkin</span>
                          </button>

                          <template v-else>

                            <section v-if="selectedIndex === index">
                              <div class="loader" style="width: 15px; height: 15px; margin 5px" />
                            </section>

                            <span  v-else class="badge badge-pill badge-success">
                                {{ (!task.api_request) ? task.checkinBy : 'API' }}
                                <a href="javascript:void(0)"  @click="checkOutFailedBackupTask({task, index})" class="fa fa-times text-white"></a>
                            </span>

                          </template>
                        </td>
                      <template v-else>
                        <td v-if="type === 'active' || type === 'migration' || type === 'uniqueVisitors'" class="text-center">
                          <button v-if="!task.checkinBy && !task.api_request" :disabled="selectedIndex === index" class="btn btn-primary btn-sm mr-2" @click="checkin(task, index)">
                            <div class="loader mini_loader" v-if="selectedIndex === index"></div>
                            <span v-else>Checkin</span>
                          </button>
                          <template v-else>
                            <section v-if="selectedIndex === index">
                              <div class="loader" style="width: 15px; height: 15px; margin 5px" />
                            </section>
                            <span  v-else class="badge badge-pill badge-success">
                                {{ (!task.api_request) ? task.checkinBy : 'API' }}
                                <a href="javascript:void(0)" v-if="!task.api_request" @click="checkOutTask(task, index)" class="fa fa-times text-white"></a>
                            </span>
                          </template>
                        </td>
                      </template>

                        <td v-if="task.text === 'BackUpFailed' && type === 'active'">
                            <div class="loader mini_loader" v-if="getTaskLoader && loading && selectedIndex === index ">

                            </div>
                            <div class="d-flex justify-content-center mr-10 ml-10" v-else-if="task.checkinBy">
                            <select   class="form-control pt-5 pb-5 pl-10 pr-10" @change="manageFailedBackedTask({event:$event.target.value ,task , index})">
                              <option value="" disabled selected>Manage</option>
                              <option v-for="(search, index) in searchByFilter" :value="search.value" v-bind:key="index"> {{ search.name }}</option>
                            </select>
                            </div>

                        </td>
                        <template v-else>
                          <td width="18%"  v-if="type === 'active' || type === 'migration' || type === 'uniqueVisitors'">
                            <button v-if="task.type==='support' && task.status === 'pending' && task.storageDetails" :disabled="loading || disabledDomainList.includes(task.domain) || checkBeforeResolveTask(task)" class="btn btn-primary btn-sm mr-2" @click="pushToSales(task, index)">
                              <div class="loader mini_loader" v-if="getTaskLoader && loading && resolvingIndex === index "></div>
                              <span v-else>Push to Sales</span>
                            </button>
                            <button v-else-if="(!tableId.toLowerCase().includes('sales') ? task.checkinBy && task.status === 'pending' : task.status === 'pending')" :disabled="loading || (task.text === 'New Staging Domain Added' && checkStagingDomain(task.domain)) || disabledDomainList.includes(task.domain) || checkBeforeResolveTask(task)" class="btn btn-primary btn-sm mr-2" @click="resolveTask(task, index)">
                              <div class="loader mini_loader" v-if="getTaskLoader && loading && resolvingIndex === index "></div>
                              <span v-else><i class="fa fa-refresh"></i> Resolve</span>
                            </button>
                            <button v-if="task.ticketID" title="View Ticket" class="btn btn-primary btn-sm ml-2" @click="viewTicket(task, index)">
                              <i class="fa fa-eye"></i>
                            </button>
                            <button v-if="type !== 'uniqueVisitors'" title="Login as user" :disabled="loading" class="btn btn-primary btn-sm ml-2" @click="loginAsUser(task, index)">
                              <i class="fa fa-user"></i>
                            </button>
                            <button v-if="type === 'active' && tableId.toLowerCase().includes('sales')" title="View Account Details" :disabled="loading" class="btn btn-primary btn-sm ml-2" @click="goToUser(task, index)">
                              <i class="fa fa-eye"></i>
                            </button>
                          </td>
                        </template>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- Modal -->
        <div class="modal fade" :id="'taskDetailModal_' + tableId" tabindex="-1" role="dialog" aria-labelledby="taskDetailModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{'Task: ' + selectedTask.text}} <br/>
                            {{'Domain: ' + selectedTask.domain}}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="padding: 30px">
                        <span v-if="selectedTask.extraDetail" v-html="getText(selectedTask.extraDetail.data)"></span>
                      <div v-else-if="selectedTask.storageDetails">
                        <span><b>JobName</b>: {{selectedTask.jobType.charAt(0).toUpperCase() + selectedTask.jobType.slice(1)}} Request</span><br><br>
                        <span><b>Current Limit</b>: {{selectedTask.storageDetails.maxStorageSize}}GB</span><br>
                        <span><b>Current Usage</b>: {{selectedTask.storageDetails.usedSpaceInGB}}GB</span><br>
                        <span><b>Disk Needed</b>: {{selectedTask.storageDetails.requiredSpace}}</span><br>
                        <span><b>{{ selectedTask.jobType.charAt(0).toUpperCase() + selectedTask.jobType.slice(1) }} Type Request</b>:  {{getType(selectedTask.storageDetails.selectedOption)}}</span><br>
                        <hr style="border-width: 3px; margin-bottom: 5px; margin-top: 5px">
                        <span><b>Extra Suggested</b>: {{selectedTask.storageDetails.recommendedStorage}}GB</span><br>
                        <span><b>New Total</b>: {{Number(selectedTask.storageDetails.recommendedStorage) + Number(selectedTask.storageDetails.maxStorageSize)}}GB</span><br>
                      </div>
                      <span v-else></span>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {db} from "@/firebase/init";
    import _ from 'lodash';
    import swal from 'sweetalert2';
    import autoLink from 'autolink.js';
    import moment from 'moment';
    import copyButtonMixin from '../../../mixins/copyButtonMixin';
    import statisticsMixin from '../../../mixins/statisticsMixin';
    import tippy from 'tippy.js';
    import 'tippy.js/dist/tippy.css';
    export default {
        name: "TaskListComp",
      mixins: [copyButtonMixin, statisticsMixin],
        props: {
            tasks: {
                type: Array,
                required: true
            },
            type: {
                type: String,
                required: true
            },
            tableId: {
                type: String,
                required: true
            },
        },
        data () {
          return {
              loading: false,
              selectedTask: {
                  extraDetail: {
                      data: ''
                  }
              },
              selectedIndex: -1,
              resolvingIndex: -1,
              resolveAllLoader: false,
              hbStatuses: [],
            searchByFilter: [
              {name: 'Resolve', value: true},
              {name: 'Resume Forcefully', value: false}
            ],
            searchBy: '',
            disabledDomainList: [],
            runningJobSnap: null,
            runningCronSnap: null,
            task : null,
          }
        },
        computed: {
          getTaskLoader() {
            return this.$store.getters['tasks/getTaskLoader'];
          },
          user () {
              return this.$store.getters.user;
          },
        },
        updated () {
            /* eslint-disable */
            const self = this;
          const copyIcons =  document.getElementsByClassName('click-to-copy');
          if (copyIcons.length) {
            copyIcons[0].setAttribute('id', 'copy1');
            copyIcons[1].setAttribute('id', 'copy2');
          }
          const copy1 = document.getElementById('copy1');
          console.log('copy 1', copy1)
          if (copy1) {
            copy1.onclick = function () {
              console.log('copy 1 clicked')
              const text = $(this).prev().text();
              const textField = document.createElement('textarea');
              textField.innerText = text;
              document.body.appendChild(textField);
              textField.select();
              textField.focus(); //SET FOCUS on the TEXTFIELD
              document.execCommand('copy');
              textField.remove();
              console.log('should have copied ' + text);
              self.$notify({
                group: 'foo',
                title: 'Message',
                text: 'Copied!'
              });
            }
          }
          const copy2 = document.getElementById('copy2');
          if (copy2) {
            copy2.onclick = function () {
              console.log('copy 2 clicked')
              const text = $(this).prev().text();
              const textField = document.createElement('textarea');
              textField.innerText = text;
              document.body.appendChild(textField);
              textField.select();
              textField.focus(); //SET FOCUS on the TEXTFIELD
              document.execCommand('copy');
              textField.remove();
              console.log('should have copied ' + text);
              self.$notify({
                group: 'foo',
                title: 'Message',
                text: 'Copied!'
              });
            }
          }

          // $(".click-to-copy").click(function() {
          //     console.log(self.$refs.copy.firstChild)
          //     console.log('clicked')
          //       const text = $(this).prev().text();
          //       const textField = document.createElement('textarea');
          //       textField.innerText = text;
          //       document.body.appendChild(textField);
          //       textField.select();
          //       textField.focus(); //SET FOCUS on the TEXTFIELD
          //       document.execCommand('copy');
          //       textField.remove();
          //       console.log('should have copied ' + text);
          //       self.$notify({
          //           group: 'foo',
          //           title: 'Message',
          //           text: 'Copied!'
          //       });
          //   });
            /* eslint-enable */
        },
        mounted () {
          $('[data-toggle="tooltip"]').tooltip();

            if(this.tableId === 'activeSupportTasksTable'){
                // this.loadHBTicketStatuses();
            }
            const tablesWithSnapShot = ['activeSupportTasksTable' , 'activeSupportTasksTableBackups', 'activeSupportTasksTableMigrations', 'activeSupportTasksTableUniqueVisitors', 'activeSupportTasksTableCPanelSupportTaskTable']
            if (this.tableId) {
            $(`#${this.tableId}`).DataTable({
              pagingType: "full_numbers",
              lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
              destroy: true,
              retrieve: true,
              deferRender: true,
              "ordering": false,
              stateSave: true,
              language: {
                search: "_INPUT_",
                searchPlaceholder: "Search Task",
                size: 50
              }
            });
          }

            this.getPendingJobs()
        },
        methods: {
          async checkinFailedBackupTask(data){
            const { index, task } = data
            this.selectedIndex = index;
            try{
              await db.collection('bigScootsTasks').doc(task.docId).update({checkinBy: `${this.user.firstName} ${this.user.lastName}`});
              task.checkinBy = `${this.user.firstName} ${this.user.lastName}`;
            }
            catch(e){
              console.log('failed to check in task', e.toString())
            }
            try{
              await this.$http.post('/clone/checkFailedStorageTask', {
                task,
                isCheckedIn: true,
                grant_type: 'token',
              });
            }
            catch(e){
              console.log('failed to update slack message for failed storage', e.toString())
            }
            finally {
              this.selectedIndex = null;
            }
          },
          async checkOutFailedBackupTask(data){
            const { index, task } = data
            this.selectedIndex = index;
            try{
              await db.collection('bigScootsTasks').doc(task.docId).update({ checkinBy: ''});
              task.checkinBy = '';
            }
            catch(e){
              console.log('failed to check in task', e.toString())
            }
            try{
              await this.$http.post('/clone/checkFailedStorageTask', {
                task,
                isCheckedIn: false,
                grant_type: 'token',
              });
            }
            catch(e){
              console.log('failed to update slack message for failed storage', e.toString())
            }
            finally {
              this.selectedIndex = null;
            }
          },
          async manageFailedBackedTask(data){
            const { index, event, task } = data
            this.selectedIndex = index;
            console.log(event, task)
            try{
              const {jobData} = task;
              jobData.createBackup = event;
              await this.$http.post('/clone/queue', {
                ...jobData,
                supportTaskStorageFlag: true,
                grant_type: 'token',
                skipFromAdmin: true
              });
            }
            catch(e){
             console.log('error occurred while adding cloning job for failed storage task', e.toString())
            }
          finally {
              this.selectedIndex = -1;
            }
          },
          getDate(date) {
            return moment(date).format('DD MMM, YYYY hh:mm a')
          },
          async activateCloudflareEnterprise(data) {
            try {
              console.log('emitting')
              data.from = 'support';
              this.$emit('loadActivateCfModal', data)
            } catch (e) {
              console.log('error at 1266', e.toString())
            }
          },
          checkStagingDomain(stagingDomain) {
            console.log('stagingDomain', stagingDomain)
            let flag = false;
            for(const row of this.disabledDomainList) {
              const staging = `${row.replace(/\./g, '')}.bigscoots-staging.com`
              if(staging === stagingDomain) {
                console.log('true')
                flag = true;
                break
              }
            }
            return flag;
          },
          checkBeforeResolveTask (task) {
            const name = `${this.user.firstName} ${this.user.lastName}`;
            if (task.type === 'sales') {
              return task.checkinBy ? task.checkinBy !== name : false;
            }
            return  !task.checkinBy || task.checkinBy !== name;
          },
          async checkin (task, index) {
            try {
              this.selectedIndex = index;
              const ref = await db.collection('bigScootsTasks').doc(task.docId).get();
              if (ref.exists) {
                await db.collection('bigScootsTasks').doc(task.docId).update({checkinBy: `${this.user.firstName} ${this.user.lastName}`});
                task.checkinBy = `${this.user.firstName} ${this.user.lastName}`;
              }
              if (task.ticketID) {
                try {
                  await this.$http.post('/host-bill/add-ticket-tag', {
                    ticketId: task.ticketID,
                    grant_type: 'token',
                    tag: `${this.user.firstName} ${this.user.lastName}`
                  })
                  await this.$http.post('/host-bill/update-ticket-status', {
                    ticketNumber: task.ticketID,
                    grant_type: 'token',
                    status: 'In-Progress'
                  })
                } catch (e) {
                  console.log(e.toString())
                }
              }
              const email = task.email ? task.email : null;
              const domain = task.domain ? task.domain : null;
              const message = domain !== null ?
                  `${task.type === 'sales' ? 'Sales' : 'Support'} task for domain ${this.domainAdjustment(task.domain)} has been checked in by ${this.user.firstName} ${this.user.lastName}.`
                  :
                  `${task.type === 'sales' ? 'Sales' : 'Support'} task has been checked in by ${this.user.firstName} ${this.user.lastName}.`
              const data = {
                taskId: task.docId,
                ticketId: task.ticketID ? task.ticketID : null,
                type  : 'info',
                actionType: `${task.type} Task`,
                message: message,
                customer: {
                  email: email,
                  domain: task.domain
                }
              };
              await this.addRecentActivity({...data})
              await this.addToAdminActiveTask({...data , text: task.text , ip: task.ip, hbDocId: task.hbDocId });
              if(task.text === 'New Storage Request' && task.type === 'support') {
                try {
                  await this.$http.post('/utilities/send-slack-notification-for-task/reminder', {
                    grant_type: 'token',
                    checkinBy: `${this.user.firstName} ${this.user.lastName}`,
                    docId: task.docId,
                    domain: task.domain,
                    actionType: 'checkin',
                    action: 'update'
                  })
                } catch (e) {
                  console.log('error from slack api', e.toString())
                }
              }
              // swal('Success', 'You have successfully checked in!', 'success');
            } catch (e) {
              console.log('error from checkin function ==> ', e.toString())
              swal('Error', 'Something went wrong while checkin!', 'error');
            } finally {
              this.selectedIndex = -1;
            }
          },
          async checkOutTask (task, index) {
            try {
              this.selectedIndex = index;
              const ref = await db.collection('bigScootsTasks').doc(task.docId).get();
              if (ref.exists) {
                await db.collection('bigScootsTasks').doc(task.docId).update({ checkinBy: ''});
                task.checkinBy = '';
              }
              const email = task.email ? task.email : null;
              const domain = task.domain ? task.domain : null;
              const message = domain !== null ?
                  `${task.type === 'sales' ? 'Sales' : 'Support'} task for domain ${this.domainAdjustment(task.domain)} has been checked out by ${this.user.firstName} ${this.user.lastName}.`
                  :
                  `${task.type === 'sales' ? 'Sales' : 'Support'} task has been checked out by ${this.user.firstName} ${this.user.lastName}.`
              const data= {
                taskId: task.docId,
                type  : 'info',
                actionType: `${task.type} Task`,
                message: message,
                customer: {
                  email: email,
                  domain: task.domain
                }
              }
              await this.addRecentActivity({...data});
              try{
                await this.removeAdminActiveTask({taskId: task.docId});
              } catch (e) {
                console.log(e.toString())
              }
            } catch (e) {
              console.log('error from checkin function ==> ', e.toString())
              swal('Error', 'Something went wrong while checkout!', 'error');
            } finally {
              this.selectedIndex = -1;
            }
          },
          async getPendingJobs () {
            const query = db.collection('jobLogs')
                .where('jobName', '==', 'domain-create')
                .where('status', 'in', ['Pending', 'running', 'paused']);
            this.runningJobSnap = query.onSnapshot(snapshot => {
              snapshot.docChanges().forEach((change) => {
                const data = change.doc.data();
                if (change.type === 'added') {
                  this.disabledDomainList.push(data.inputDomain)
                } else if (change.type === 'removed') {
                  this.disabledDomainList = this.disabledDomainList.filter(d=> d !== data.inputDomain)
                }
              })
            });
            const query1 = db.collection('jobLogs')
                .where('jobName', '==', 'CHECK-SERVER-CRON')
                .where('status', 'in', ['Pending', 'running', 'paused']);
            this.runningCronSnap = query1.onSnapshot(snapshot => {
              snapshot.docChanges().forEach((change) => {
                const data = change.doc.data();
                if (change.type === 'added') {
                  this.disabledDomainList.push(data.inputDomain)
                }
              })
            });
          },
          getText (data) {
            return data.replace(/<script/g, '').replace(/<script\/>/g, '').replace(/\n/g, `<br/>`)
                .replace(/<img/g, '').replace(/<a/g, '<a rel=”noopener noreferrer”').replace(/<a\/>/g, '').replace(/<link\/>/g, '')
          },
          async removeTask(task){
            try {
              this.loading=true;
              console.log('task', task);
              await db.collection('bigScootsTasks').doc(task.docId).delete();
              this.showToast({message: 'Support task has been deleted successfully.' , duration: 4000}, true, 'success')

            } catch (e) {
              console.log('error when deletig support task', e.toString())
              this.showToast({message: 'Something went wrong while deleting support task.' , duration: 4000}, true, 'danger')
            }


          },
          async goToUser (data) {
            this.loading=true;
            const userRef=await db.collection('users').where('email', '==', data.email).limit(1).get()
            let user=null
            if(userRef.size>0){
              userRef.forEach(el => {
                user= {id: el.id, ...el.data()}
              })
              this.$router.push({ name: 'editUser', params: { docID: user.id } })
            }else{
              swal('Error!', 'User not found!', 'error');
            }
            this.loading=false
            console.log('data',data)
          },
          async loginAsUser(data){
            this.loading=true
            const userRef=await db.collection('users').where('email', '==', data.email).limit(1).get()
            let user=null
            if(userRef.size>0){
              userRef.forEach(el => {
                user= {id: el.id, ...el.data()}
              })
              window.open(`https://wpo.bigscoots.com/user/dashboard?id=${user.id}`,'WPO-Bigscoots');
            }else{
              swal('Error!', 'User not found!', 'error');
            }
            this.loading=false
          },
          viewTicket(data){
            window.open(`https://portal.bigscoots.com/admin/?cmd=tickets&action=view&num=${data.ticketID}`, '_blank')
          },
            calculateTime(time){
            let date1 = new Date(time);
            let date2 = new Date();

            const ms = moment(date2,"DD/MM/YYYY HH:mm:ss").diff(moment(date1,"DD/MM/YYYY HH:mm:ss"));
            const d = moment.duration(ms);
            let diff = '';
            if (d.days() > 0) {
              diff += d.days() + ' days ';
            }
            if (d.hours() > 0) {
              diff += d.hours() + ' hours ';
            }
            if (d.minutes() > 0) {
              diff += d.minutes() + ' minutes ';
            }
            if (!diff) {
              diff = 'Now'
            }
            return diff //d.days() + ' days ' + d.hours() + ' hours ' + d.minutes() + ' minutes '

            },
          async unPauseServer (data) {
            try {
              await this.$http.post('/utilities/resume-server', {
                grant_type: 'token',
                ip: data.ip,
                hbDocId: data.hbDocId
              })
            } catch (e) {
              await this.addLog({
                message: `Error in resuming server to check disk space again IP: ${data.ip}`,
                level: "error"
              })
              console.log(e.toString())
            }
          },
            async loadHBTicketStatuses () {
              console.log('insode load')
                for(const task of this.tasks){
                    // console.log(task);
                    if(task.ticketID) {
                      const response = await this.$http.post('host-bill/fetch-ticket-details', {
                      ticketID: task.ticketID,
                      grant_type: 'token'
                      });
                      this.hbStatuses.push(response.data.ticket.status)
                      // const checkTicketStatus = functions.httpsCallable("checkTicketStatus");
                      // await checkTicketStatus({
                      //       ticketID: task.ticketID
                      //   }).then(result => {
                      //       this.hbStatuses.push(result.data.status);
                      //   });
                    } else {
                        this.hbStatuses.push('N/A');
                    }
                }
            },
            resolveAllBackupTasks () {
                swal({
                    title: "Are you sure?",
                    text: `Are you sure you want to resolve all backup failure tasks?`,
                    type: "question",
                    confirmButtonText: "Yes Proceed",
                    confirmButtonColor: "#6ACF98",
                    showCancelButton: true,
                    cancelButtonText: "No Thanks",
                    cancelButtonColor: "#EE8057"
                }).then(async result => {
                    if(result.value) {
                        let collectionRef = db.collection("bigScootsTasks")
                            .where('text', '==', 'Backup Failure')
                            .where('status', '==', 'pending');
                        collectionRef.get().then(async docs => {
                            const batchSize = 500;
                            let totalBatches = Math.ceil(docs.size / batchSize);
                            console.log(docs.size);
                            console.log('Total Batches: ' + totalBatches);
                            let docReferences = [];
                            docs.forEach(doc => {
                                docReferences.push(doc.ref);
                            });
                            for(let b = 0; b < batchSize; b++) {
                                let batch = db.batch();
                                let startIndex = b * batchSize;
                                let endIndex = (((batchSize + startIndex) < docs.size)) ? batchSize + startIndex : docs.size;
                                console.log(startIndex, endIndex);
                                for(let d = startIndex; d < endIndex; d++){
                                    batch.update(docReferences[d], {
                                        status: 'resolved',
                                        resolvedAt: new Date().toISOString(),
                                        resolvedBy: this.user.firstName + ' ' + this.user.lastName
                                    });
                                }
                                await batch.commit();
                            }
                        })
                    }
                })
            },

            async pushToSales (task, index) {
              this.resolvingIndex = index;
              this.loading = true;
              await this.$store.dispatch('tasks/changeTaskLoader', true);
              try {
                const {jobType, jobData} = task;
                let result = null
                if (jobType === 'staging') {
                  result = await this.$http.post('/staging-request/queue', {
                    ...jobData,
                    grant_type: 'token',
                    skipFromAdmin: true
                  });
                } else if (jobType === 'cloning') {
                  result =await this.$http.post('/clone/queue', {
                    ...jobData,
                    grant_type: 'token',
                    skipFromAdmin: true
                  });
                }
                if(task.text === 'New Storage Request' && task.type === 'support') {
                  try {
                    await this.$http.post('/utilities/send-slack-notification-for-task/reminder', {
                      grant_type: 'token',
                      checkinBy: task.checkinBy,
                      docId: task.docId,
                      domain: task.domain,
                      resolvedBy: this.user.firstName + ' ' + this.user.lastName,
                      actionType: 'resolve',
                      action: 'update'
                    })
                  } catch (e) {
                    console.log('error from slack api', e.toString())
                  }
                }
                await db.collection('bigScootsTasks').doc(task.docId).update({
                  type: 'sales',
                  checkinBy: '',
                  showCustomToast: true,
                  toastData: {
                    timer: 5,
                    message: `We have added ${task.storageDetails.recommendedStorage} GB additional storage to your WPO plan. Resuming ${task.jobType} process now.`,
                    title: 'Storage Added Successfully',
                    status: 'completed'
                  }
                });
              } catch (e) {
                console.log(e.toString())
              }
              this.loading = false;
              this.resolvingIndex = -1;
            },
            async resolveTask (task, index) {
            this.task= task
                // const result = await swal({
                //   title: "Are you sure?",
                //   text: `Please confirm that you would like to resolve this request.`,
                //   type: "question",
                //   confirmButtonText: "Yes Proceed",
                //   confirmButtonColor: "#6ACF98",
                //   showCancelButton: true,
                //   cancelButtonText: "No Thanks",
                //   cancelButtonColor: "#EE8057"
                // });
                // if (!result.value) {
                //   return
                // }
                this.resolvingIndex = index;
                this.loading = true;
                let errorInResolving = false;
                await this.$store.dispatch('tasks/changeTaskLoader', true);
                if(task.text === 'New Domain Added' && task.type === 'support') {
                  // set ticket status to answered
                  try {
                    if (task.ticketID) {
                      await this.$http.post('/host-bill/update-ticket-status', {
                        grant_type: 'token',
                        status: 'Answered',
                        ticketNumber: task.ticketID
                      })
                    }
                  } catch (e) {
                    console.log('Something went wrong while setting status of ticket to answered')
                  }
                  let ref = await db.collection('jobLogs')
                    .where('inputDomain', '==', task.domain)
                    .where('jobName', '==', 'domain-create')
                    .where('status', 'in', ['Pending', 'running', 'paused']).get();
                    if (ref.size) {
                      this.resolvingIndex = -1;
                      this.loading = false;
                      swal('Please wait!', 'Create domain job is running for this domain yet.', 'error');
                      return true
                    }
                    console.log('Mark HB Ticket as low / Reply to HB Ticket / make domain active / status cake active');
                    console.log(task);
                    await this.$http.post('/domain/resolve-support-task', {
                        grant_type: 'token',
                        domain: task.domain,
                        email: task.email,
                        ticketNumber: task.ticketID
                    }).catch(e => {
                        console.error(e);
                        errorInResolving = true;
                        this.resolvingIndex = -1;
                        let self=this
                      let buttonHtml = '<div>' +
                          `<div>${e.response.data.msg}</div>` +
                          '<br/>' +
                          '<ul class="list-inline">' +
                          '<li><button class="sw_butt1 swal2-styled" style="display: inline-block;background-color: rgb(106, 207, 152); border-left-color: rgb(106, 207, 152); border-right-color: rgb(106, 207, 152);">Resolve</button></li>' +
                          '<li><button class="sw_butt2 swal2-styled" style="display: inline-block; background: #e6c652" >Delete</button></li>' +
                          '<li><button class="sw_butt3 swal2-styled" style="display: inline-block; background-color: rgb(238, 128, 87);">Cancel</button></li>' +
                          '</ul></div>';
                      swal({
                        title: "Error",
                        html: buttonHtml,
                        type: 'question',
                        showCancelButton: false,
                        showConfirmButton: false,
                        onOpen: function () {
                          console.log('On Opne');
                          /* eslint-disable */
                          $('.sw_butt1').on('click',async function () {
                            await db.collection('bigScootsTasks').doc(task.docId).update({
                              status: 'resolved',
                              resolvedAt: new Date().toISOString(),
                              resolvedBy: self.user.firstName + ' ' + self.user.lastName
                            });
                            const email = task.email ? task.email : null;
                            const domain = task.domain ? task.domain : null;
                            const message = domain !== null ?
                                `${task.type === 'sales' ? 'Sales' : 'Support'} task for domain ${this.domainAdjustment(task.domain)} has been resolved by ${self.user.firstName} ${self.user.lastName}.`
                                :
                                `${task.type === 'sales' ? 'Sales' : 'Support'} task has been resolved by ${self.user.firstName} ${self.user.lastName}.`
                            await self.addRecentActivity({
                              type  : 'info',
                              actionType: `${task.type} Task`,
                              message: message,
                              customer: {
                                email: email,
                                domain: task.domain
                              }
                            })
                            try {
                              await self.removeAdminActiveTask({taskId: task.docId});
                            } catch (e) {
                              console.log(e.toString())
                            }
                            swal.close();
                          });
                          $('.sw_butt2').on('click',async function () {
                            await db.collection('bigScootsTasks').doc(task.docId).delete()
                            try {
                              await self.removeAdminActiveTask({taskId: task.docId});
                            } catch (e) {
                              console.log(e.toString())
                            }
                            swal.close();
                          });
                          $('.sw_butt3').on('click',function () {
                            console.log('close');
                            swal.close();
                          });
                          /* eslint-enable */
                        }
                      });
                        // swal('Error!', e.response.data.msg, 'error');
                    })
                } else if (task.text === 'New Staging Domain Added' && task.type === 'support' && task.ticketID) {
                  await this.$http.post('/host-bill/update-ticket-status', {
                    grant_type: 'token',
                    domain: task.domain,
                    email: task.email,
                    ticketNumber: task.ticketID,
                    status: 'Answered'
                  }).catch(e => {
                    console.error(e);
                    this.resolvingIndex = -1;
                    errorInResolving = true;
                    let self=this
                    let buttonHtml = '<div>' +
                        '<div>{{e.response.data.msg}}</div>' +
                        '<br/>' +
                        '<ul class="list-inline">' +
                        '<li><button class="sw_butt1 swal2-styled" style="display: inline-block;background-color: rgb(106, 207, 152); border-left-color: rgb(106, 207, 152); border-right-color: rgb(106, 207, 152);">Resolve</button></li>' +
                        '<li><button class="sw_butt2 swal2-styled" style="display: inline-block; background: #e6c652" >Delete</button></li>' +
                        '<li><button class="sw_butt3 swal2-styled" style="display: inline-block; background-color: rgb(238, 128, 87);">Cancel</button></li>' +
                        '</ul></div>';
                    swal({
                      title: "Error",
                      html: buttonHtml,
                      type: 'question',
                      showCancelButton: false,
                      showConfirmButton: false,
                      onOpen: function () {
                        console.log('On Opne');
                        /* eslint-disable */
                        $('.sw_butt1').on('click',async function () {
                          await db.collection('bigScootsTasks').doc(task.docId).update({
                            status: 'resolved',
                            resolvedAt: new Date().toISOString(),
                            resolvedBy: self.user.firstName + ' ' + self.user.lastName
                          });
                          const email = task.email ? task.email : null;
                          const domain = task.domain ? task.domain : null;
                          const message = domain !== null ?
                              `${task.type === 'sales' ? 'Sales' : 'Support'} task for domain ${this.domainAdjustment(task.domain)} has been resolved by ${self.user.firstName} ${self.user.lastName}.`
                              :
                              `${task.type === 'sales' ? 'Sales' : 'Support'} task has been resolved by ${self.user.firstName} ${self.user.lastName}.`
                          await self.addRecentActivity({
                            type  : 'info',
                            actionType: `${task.type} Task`,
                            message: message,
                            customer: {
                              email: email,
                              domain: task.domain
                            }
                          })
                          try{
                            await this.removeAdminActiveTask({taskId: task.docId});
                          } catch (e) {
                            console.log(e.toString())
                          }
                          swal.close();

                        });
                        $('.sw_butt2').on('click',async function () {
                          await db.collection('bigScootsTasks').doc(task.docId).delete()
                          try {
                            await self.removeAdminActiveTask({taskId: task.docId});
                          } catch (e) {
                            console.log(e.toString())
                          }
                          swal.close();
                        });
                        $('.sw_butt3').on('click',function () {
                          console.log('close');
                          swal.close();
                        });
                        /* eslint-enable */
                      }
                    });
                    // swal('Error!', e.response.data.msg, 'error');
                  })
                } else if (task.text === 'New CF Enterprise Request' && task.type === 'sales') {
                  if (task.formData) {
                    try {
                      await db.collection('CFEnterpriseRequests').add(task.formData)
                    } catch (e) {
                      console.log('error in adding CF task')
                    }
                  }
                  try {
                    let date = moment().tz('America/Chicago').format('YYYY-MM-DD HH:mm:ss');
                    let folderName = date.replace(/:/g, '_').replace(' ', 'T')
                    await this.requestToQueueBackupJob(date, 'manual-' + folderName, 'create', 'Backup (Before) - Performance Plan Setup', task);
                  } catch (e) {
                    console.log('Error in adding backup job', e.toString())
                  }
                }
                if(!errorInResolving) {
                    if (task.unPauseServer) {
                      // unpause server
                      await this.unPauseServer(task);
                    }
                    await db.collection('bigScootsTasks').doc(task.docId).update({
                        status: 'resolved',
                        resolvedAt: new Date().toISOString(),
                        resolvedBy: this.user.firstName + ' ' + this.user.lastName
                    });
                  const email = task.email ? task.email : null;
                  const domain = task.domain ? task.domain : null;
                  const message = domain !== null ?
                      `${task.type === 'sales' ? 'Sales' : 'Support'} task for domain ${this.domainAdjustment(task.domain)} has been resolved by ${this.user.firstName} ${this.user.lastName}.`
                      :
                      `${task.type === 'sales' ? 'Sales' : 'Support'} task has been resolved by ${this.user.firstName} ${this.user.lastName}.`

                  const data= {
                    type  : 'info',
                    actionType: `${task.type} Task`,
                    message: message,
                    customer: {
                      email: email,
                      domain: task.domain
                    }};
                  await this.addRecentActivity({...data})
                  try{
                    await this.removeAdminActiveTask({taskId: task.docId});
                  } catch (e) {
                    console.log(e.toString())
                  }
                } else {
                  await this.addLog({
                    primaryPlan: 'Account Based Operation',
                    message: `User has resolved a support task for Domain: ${task.domain}, Type: ${task.text} `,
                    level: "info"
                  })
                }
                try{
                  await this.incrementCountBasedOnType(this.user, 'support')
                }catch (e) {
                  console.log('line 392', e.toString())
                }
                this.loading = false;
                this.resolvingIndex = -1;
            },
            formattedText(text) {
                return autoLink(text, {
                    // default options:
                    email: true,
                    image: true,
                    linkAttr: {
                        'target': '_blank',
                        'rel': 'nofollow'
                    },
                    // \n to <br/>
                    br: true
                })
            },
            openDetailModal (task) {
                this.selectedTask = _.cloneDeep(task);
                /* eslint-disable */
                $("#taskDetailModal_" + this.tableId).modal("show");
                $('.modal-backdrop').removeClass("modal-backdrop");
                /* eslint-enable */
            },
            openStorageDetailModal (task) {
              this.selectedTask = _.cloneDeep(task);
              /* eslint-disable */
              $("#taskDetailModal_" + this.tableId).modal("show");
              $('.modal-backdrop').removeClass("modal-backdrop");
              /* eslint-enable */
            },
            nl2br(str, isXhtml) {
                const breakTag = isXhtml ? '<br />' : '<br>';
                return String(str).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, `$1${breakTag}$2`);
            },
          getType (str) {
            const list = {
              "SKIPUPLOADS": 'Excluding Media',
              "SYNCUPLOADS": 'Sync Uploads',
              "fresh": 'Fresh Install',
              "OVERWRITEALL": 'Including Media',
            }
            return `${list[str]}`
          },
          async requestToQueueBackupJob(backupDate, backupName, operation, notes, row){
            try {
              await this.$http.post('backup/queue', {
                ip: row.ip,
                domain: row.domain,
                grant_type: "token",
                firstName: row.firstName,
                lastName: row.firstName,
                email: row.email,
                UID: row.UID,
                backupName: backupName,
                backupDate: backupDate,
                operation: operation,
                backupNotes: notes,
                envType: 'live',
                collaborator: '0',
                collaboratorUID: row.UID,
                collaboratorEmail: row.email
              })
            } catch (e) {
              console.log('Error in adding backup job', e.toString())
            }
          },

          async unResolveTask(task, index) {
            try {
              this.selectedIndex = index;
              const ref = await db.collection('bigScootsTasks').doc(task.docId).get();
              if (ref.exists) {
                await db.collection('bigScootsTasks').doc(task.docId).update({ checkinBy: ''});
                task.status = 'active';
                task.resolvedAt = '';
                task.resolvedBy = '';
              }
              const email = task.email ? task.email : null;
              const domain = task.domain ? task.domain : null;
              const message = domain !== null ?
                  `${task.type === 'sales' ? 'Sales' : 'Support'} task for domain ${this.domainAdjustment(task.domain)} has been unresolved out by ${this.user.firstName} ${this.user.lastName}.`
                  :
                  `${task.type === 'sales' ? 'Sales' : 'Support'} task has been unresolved out by ${this.user.firstName} ${this.user.lastName}.`
              const data= {
                taskId: task.docId,
                type  : 'info',
                actionType: `${task.type} Task`,
                message: message,
                customer: {
                  email: email,
                  domain: task.domain
                }
              }
              const updated = this.tasks.filter(t => t.docId !== task.docId);
              console.log(updated, 'this here')
              this.$emit('update:tasks', updated);
              await this.addRecentActivity({...data});
              try{
                await this.removeAdminActiveTask({taskId: task.docId});
              } catch (e) {
                console.log(e.toString())
              }
            } catch (e) {
              console.log('error from checkin function ==> ', e.toString())
              swal('Error', 'Something went wrong while checkout!', 'error');
            } finally {
              this.selectedIndex = -1;
            }
          },
        },
      beforeDestroyed(){
        console.log('Before destroying, release all listeners...');
        if (this.runningJobSnap) {
          this.runningJobSnap();
        }
        if (this.runningCronSnap) {
          this.runningCronSnap();
        }
      },
    }
</script>

<style scoped lang="scss">
    .task-container{
        padding: 1.5em;
    }
    .cf-status-icons {
        i {
            font-size: 25px;

            &.disabled {
                color: #7E7E7E;
            }

            &.enabled {
                color: #47f260;
            }

            &.yellow {
                color: #f2b61d;
            }
        }
    }
    .click-to-copy{
        margin: 0 !important;
        padding: 7px !important;
    }
</style>
